// en, de, fr, pt
export default {
	en: {
		survey_name: 'Satisfaction Survey',
		survey_title: 'Customer',
		survey_subtitle: 'Satisfaction Survey',
		survey_message: 'Your opinion is important to us',
		survey_table_option1: 'Excellent',
		survey_table_option2: 'Good',
		survey_table_option3: 'Acceptable',
		survey_table_option4: 'Bad',
		survey_hotel: 'Hotel:',
		survey_treatment: 'Treatment',
		survey_therapist: 'Therapist Name',
		survey_comments: 'Comments',
		survey_thanks: 'Thanks you for your commments.',
		survey_bad: 'Please select one option for each question',
		survey_good: 'Thanks for your collaboration',
		survey_bad_message: 'The survey has already been answered',
		survey_button: 'Submit',
		survey_group1: 'Reception',
		survey_group2: 'Treatment',
		survey_group3: 'Facilities',
		survey_group1_item1: 'Warm welcome',
		survey_group1_item2: 'Consultation card',
		survey_group1_item3: 'General communication',
		survey_group2_item1: 'Care and attention',
		survey_group2_item2: 'Therapeutic technics',
		survey_group2_item3: 'Products quality',
		survey_group3_item1: 'Maintenance conditions',
		survey_group3_item2: 'Hygienic standards',
		survey_group3_item3: 'Environment',
		salutation: 'Hi',
		tr_to_en: 'English',
		tr_to_fr: 'French',
		tr_to_de: 'German',
		tr_to_pt: 'Portuguese',
		tr_to_es: 'Spanish',
		scheduleLegend: 'Rooms',
		SideMenuOption1: 'Bookings',
		SideMenuOption2: 'Client Data',
		SideMenuOption3: 'Consult',
		SideMenu3SubOption1: 'By Therapist',
		SideMenu3SubOption2: 'By Room',
		SideMenuOption4: 'Settings',
		SideMenu4SubOption1: 'Spa',
		SideMenu4SubOption2: 'Event',
		SideMenu4SubOption3: 'Room',
		SideMenu4SubOption4: 'Therapist',
		SPA: 'SPA',
		SPA_exploracao: 'SPA Exploração',
		SideMenuOption5: 'Times',
		outras_marcacoes: 'Other Bookings',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
    	FullCalendar: 'Full Calendar',
    	SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
		Cart: 'Cart',
   		WishList: 'Wish List',
		Checkout: 'Checkout',
		UIElements: 'UI Elements',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
    	CardColors: 'Card Colors',
		Table: 'Table',
    	agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
    	ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
    	FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
    	Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
    	DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		EditorView: 'Editor View',
		AdminView: 'Admin View',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
    	StarRatings: 'Star Ratings',
    	Autocomplete: 'Autocomplete',
    	Tree: 'Tree',
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
		cliente_externo: 'External Guest',
		socio: 'Spa Member',
		hospede: 'Hotel Guest',
		redes_sociais: 'Social Media',
		website: 'Website',
		email: 'Email',
		recomendacao: 'Recommendation',
		hotel: 'Hotel',
		outro: 'Other',
		condicoes_cardiacas: 'Heart Condition',
		diabetes: 'Diabetes',
		asma: 'Asthma',
		epilepsia: 'Epilepsy',
		clastrofobia: 'Claustrophobia',
		problemas_de_articulacoes: 'Joint Problem',
		pressao_arterial_alta_baixa: 'High/Low Blood Pressure',
		surdez: 'Hearing Disease',
		varizes: 'Varicose Veins',
		cancro: 'Cancer',
		lesao_acidente_recente: 'Recent Injury/Accident',
		cirurgia_recente: 'Recent surgery',
		doenca_de_pele: 'Skin Disease Condition',
		gravidez: 'Pregnancy',
		amamentacao: 'Breastfeeding',
		alergias: 'Allergies',
		outras: 'Other',
		suave: 'Soft',
		media: 'Medium',
		profunda: 'Deep',
		normal: 'Normal',
		seca: 'Dry',
		oleosa: 'Oily',
		mista: 'Combination',
		nao: 'No',
		sim: 'Yes',
		desidratada: 'Dehydrated',
		envelhecida: 'Mature',
		rosacea: 'Rosacea',
		sensivel: 'Sensitive',
		hiperpigmentada: 'Hyperpigmented',
		acne: 'Acne',
		cartao_de_consulta: 'Consultation Card',
		bem_vindo_satsanga: 'Welcome to SATSANGA SPA & WELLNESS',
		preencha_frase: 'In order to maximize the wellness benefits of your treatment, we kindly ask you to read this Consultation Card, carefully and complete it, giving details as needed. Thank you for your collaboration.',
		informacao_pessoal: 'Personal Information',
		nome: 'Name',
		data_de_nascimento: 'Birthday Date',
		pais: 'Nationality',
		contacto: 'Contact',
		n_quarto: 'Room Nº',
		tomou_conhecimento_spa: 'How did you find out about our Spa?',
		qual: 'Which?',
		informacoes_medicas: 'Medical Information',
		tratamento_de_corpo: 'Body Treatment',
		marque_frase: 'Check areas to avoid with a ',
		marque_frase_2: 'and areas that should be focused with a',
		limpar: 'Clean',
		direita: 'Left',
		posterior: 'Back',
		anterior: 'Front',
		esquerda: 'Right',
		pressao_prefere: 'What type of pressure do you prefer during the massage?',
		tratamento_do_rosto: 'Face Treatment',
		tipo_de_pele: 'Skin Type',
		tratamento_dermatologia: 'Are you on any specific dermatology treatment?',
		condicoes_de_pele: 'Skin Conditions',
		termos_protecao_dados_pessoais: 'Privacy and Personal Data Protection',
		texto_proteção_dados: 'All personal information is processed under compliance of the General Data Protection Regulation and the following terms.Vila Galé - Sociedade de Empreendimentos Turísticos S.A. uses your personal information to provide beauty and massage treatments, gym and nutrition services, to guarantee our clients´ well-being during treatments, customer management, historical and statistical purposes, legal obligations, quality control and for future contacts.If consented, Vila Galé - Sociedade de Empreendimentos Turísticos S.A. will send you information about our products and services either by email, text messages or telephone call. Authorization for marketing purposes is not a legal or contractual obligation and there are no consequences for those who do not provide it. The subsequent withdrawal of consent does not compromise the lawfulness of the process based on this consent. Vila Galé - Sociedade de Empreendimentos Turísticos S.A. is the responsible for the data collected at this Satsanga Spa and will process it in accordance with its internal policies and procedures on security and confidentiality. Vila Galé Group may use third parties to send e-mails and text messages. For any inquiries you may contact the portuguese supervisory authority - Comissão Nacional de Proteção de Dados. The Data Protection Officer can be contacted directly by e-mail at dpo@vilagale.com to whom you may request at any time the access, correction, erasure, data portability and the right to object or restrict processing. We retain personal information for the period necessary to fulfil the outlined purposes, unless a longer retention period is required or permitted by applicable law.',
		compreendo_informacoes: 'I understand that this information is necessary to an efficient and safe treatment. I declare that the information provided is accurate and that there was no omission of relevant information.',
		li_e_aceito: 'I read and agree with the Privacy and Personal Data Protection Policy',
		autorizo_email: 'I wish to receive occasional emails about Satsanga Spa products, promotions and news by e-mail.',
		autorizo_sms: 'I wish to receive occasional emails about Satsanga Spa products, promotions and news by text or by phone call.',
		submeter: 'Submit',
		descricao: 'Specify',
		semanas: 'Weeks',
		agradecemos_questionario: 'Thank you for responding to our questionnaire. See you later!',
		vSelectNoResults: 'No results found.',
		campo_obrigatorio: 'Required field',
		debito_ao_quarto: 'Debit Room',
		clube_vila_gale: 'Clube Vila Galé',
		massagem_tratamento: 'Massage/Treatment',
		terapeuta: 'Therapist',
		SideMenuOption6: 'Reports',
		SideMenu6SubOption1: 'Billing',
	},
	de: {
		survey_name: 'Umfrage Zur Kundenzufriedenheit',
		survey_message: 'Ihre Meinung ist uns wichtig',	
		survey_table_option1: 'Ausgezeichnet',	
		survey_table_option2: 'Gut',	
		survey_table_option3: 'Akzeptabel',	
		survey_table_option4: 'Schlecht',	
		survey_hotel: 'Hotel:',	
		survey_treatment: 'Behandlung',	
		survey_therapist: 'Name des Therapeuten',	
		survey_comments: 'Kommentare',	
		survey_thanks: 'Danke für Ihren Kommentar',	
		survey_bad: 'Bitte wählen Sie für jede Frage eine Option aus',	
		survey_good: 'Vielen Dank für Ihre Zusammenarbeit',	
		survey_bad_message: 'Die Umfrage wurde bereits beantwortet',	
		survey_button: 'Einreichen',	
		survey_group1: 'Rezeption',	
		survey_group2: 'Behandlung',	
		survey_group3: 'Einrichtungen',	
		survey_group1_item1: 'Herzliches Willkommen',	
		survey_group1_item2: 'Informative Beratung',	
		survey_group1_item3: 'Allgemeine Kommunikation',	
		survey_group2_item1: 'Sorgfalt und Aufmerksamkeit',	
		survey_group2_item2: 'Therapeutische Verfahren',	
		survey_group2_item3: 'Qualität der Produkte',	
		survey_group3_item1: 'Erhaltungszustand',	
		survey_group3_item2: 'Hygienestandards',	
		survey_group3_item3: 'Umgebung',	
		salutation: 'Hallo',
		tr_to_en: 'Englisch',
		tr_to_fr: 'Französisch',
		tr_to_de: 'Deutsche',
		tr_to_pt: 'Portugiesisch',
		tr_to_es: 'Spanisch',
		scheduleLegend: 'Rooms',
		SideMenuOption1: 'Bookings',
		SideMenuOption2: 'Client Data',
		SideMenuOption3: 'Consult',
		SideMenu3SubOption1: 'By Therapist',
		SideMenu3SubOption2: 'By Room',
		SideMenuOption4: 'Settings',
		SideMenu4SubOption1: 'Spa',
		SideMenu4SubOption2: 'Event',
		SideMenu4SubOption3: 'Room',
		SideMenu4SubOption4: 'Therapist',
		SPA: 'SPA',
		SPA_exploracao: 'SPA Exploração',
		SideMenuOption5: 'Times',
		outras_marcacoes: 'Other Bookings',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
    	FullCalendar: 'Full Calendar',
    	SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
		Cart: 'Cart',
   		WishList: 'Wish List',
		Checkout: 'Checkout',
		UIElements: 'UI Elements',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
    	CardColors: 'Card Colors',
		Table: 'Table',
    	agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
    	ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
    	FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
    	Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
    	DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		EditorView: 'Editor View',
		AdminView: 'Admin View',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
    	StarRatings: 'Star Ratings',
    	Autocomplete: 'Autocomplete',
    	Tree: 'Tree',
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
		cliente_externo: 'Auswärtiger Kunde',	
		socio: 'Mitglied',	
		hospede: 'Gast',	
		redes_sociais: 'Soziale Netzwerke',	
		website: 'Website',	
		email: 'Email',	
		recomendacao: 'Empfehlung',	
		hotel: 'Hotel',	
		outro: 'Anders',	
		condicoes_cardiacas: 'Herzerkrankungen',	
		diabetes: 'Diabetes',	
		asma: 'Asthma',	
		epilepsia: 'Epilepsie',	
		clastrofobia: 'Klaustrophobie',	
		problemas_de_articulacoes: 'Gelenkbeschwerden',	
		pressao_arterial_alta_baixa: 'Hoher/niederer Blutdruck',	
		surdez: 'Taubheit',	
		varizes: 'Krampfadern',	
		cancro: 'Krebs',	
		lesao_acidente_recente: 'Frische Verletzung/Unfall',	
		cirurgia_recente: 'Vor kurzem erfolgte Operation',	
		doenca_de_pele: 'Hautkrankheit',	
		gravidez: 'Schwangerschaft',	
		amamentacao: 'Stillende Mutter',	
		alergias: 'Allergien',	
		outras: 'Andere',	
		suave: 'Sanft',	
		media: 'Mittel',	
		profunda: 'Stark',	
		normal: 'Normal',	
		seca: 'Trocken',	
		oleosa: 'Ölig',	
		mista: 'Gemischt',	
		nao: 'Nein',	
		sim: 'Ja',	
		desidratada: 'Dehydriert',	
		envelhecida: 'Gealtert',	
		rosacea: 'Rosacea',	
		sensivel: 'Sensibel',	
		hiperpigmentada: 'Hyperpigmentierung',	
		acne: 'Akne',	
		cartao_de_consulta: 'Behandlungskarte',	
		bem_vindo_satsanga: 'WILLKOMMEN IM SATSANGA SPA & WELLNESS',	
		preencha_frase: 'Um die Vorteile Ihrer Behandlung für Ihr Wohlergehen zu maximisieren, bitten wir Sie, diese Behandlungskarte mit Sorgfalt durchzulesen und ggf. mit den notwendigen Details auszufüllen. Vielen Dank für Ihre Mitarbeit.',	
		informacao_pessoal: 'Persönliche Informationen',	
		nome: 'Name',	
		data_de_nascimento: 'Geburtsdatum',	
		pais: 'Staatsbürgerschaft',	
		contacto: 'Telefonnummer',	
		n_quarto: 'Zimmer Nr.',	
		tomou_conhecimento_spa: 'Wie haben Sie von unserem Spa erfahren?',	
		qual: 'Welche?',	
		informacoes_medicas: 'Gesundheitsdaten',	
		tratamento_de_corpo: 'Körperbehandlung',	
		marque_frase: 'Markieren Sie die Gegenden, die vermieden werden sollen, mit einem ',	
		marque_frase_2: 'und die, denen besondere Aufmerksamkeit geschenkt werden soll, mit einem',	
		limpar: 'Sauber',	
		direita: 'Rechts',	
		posterior: 'Hinten',	
		anterior: 'Vorne',	
		esquerda: 'Links',	
		pressao_prefere: 'Welche Art von Druck ziehen Sie bei der Massage vor?',	
		tratamento_do_rosto: 'Gesichtsbehandlung',	
		tipo_de_pele: 'Hauttyp',	
		tratamento_dermatologia: 'Unterziehen Sie sich gegenwärtig einer Hautbehandlung?',	
		condicoes_de_pele: 'Hautbedingungen',	
		termos_protecao_dados_pessoais: 'Datenschutzerklärung',	
		texto_proteção_dados: 'Der Schutz personenbezogener Daten entspricht den allgemeinen Datenschutzbestimmungen sowie folgenden Zusatzbestimmungen. Vila Galé – Sociedade de Empreendimentos Turísticos S.A. nutzt die im Rahmen des Betriebs des Spa Satsanga erhobenen Daten für folgende Zwecke: ästhetische und Schönheitsbehandlungen, Massagebehandlungen, Fitness- und Wellnessaktivitäten, Ernährungsdienste, Sicherstellung des Wohlseins und des leiblichen Wohlergehens der Kunden während der Behandlung, Rechnungsstellung, Kundenbetreuung, historische und statistische Zwecke, rechtliche Verpflichtungen, Kontrolle der Qualität der Dienstleistungen sowie künftige Kontakte. Wir erbitten Ihr Einverständnis für die Zustellung aktueller Informationen über die Tätigkeit des Spa Satsanga, über Produkte, Dienstleistungen, Angebote und Kampagnen per Email oder Telefon. Die Zustimmung für Marketingzwecke ist keine gesetzliche oder vertragliche Verpflichtung und ihre Nichterteilung zeitigt keinerlei Konsequenzen. Der spätere Widerruf der Zustimmung stellt die Rechtmäßigkeit der aufgrund dieser Zustimmung erfolgten Behandlung nicht in Frage. Vila Galé – Sociedade de Empreendimentos Turísticos S.A. ist verantwortlich für die Verarbeitung der im Spa Satsanga dieses Hotels Vila Galé erhobenen Daten. Um die Sicherheit der erhobenen personenbezogenen Daten zu gewährleisten, behandeln wir die uns zur Verfügung gestellten Daten vertraulich. Vila Galé – Sociedade de Empreendimentos Turísticos S.A. kann die Dienste Dritter zum Versand von Emails und SMS in Anspruch nehmen. Das Datensubjekt kann bei der zuständigen Aufsichtsbehörde – der portugiesischen Datenschutzbehörde [Comissão Nacional de Proteção de Dados ] Beschwerde einlegen. Der Datenschutzbeauftragte kann über die Emailadresse dpo@vilagale.com angeschrieben werden; an dieser Adresse kann der Kunde jederzeit eine Kopie seiner personenbezogenen Daten anfordern, seine Zustimmung widerrufen, die Löschung, Beschränkung oder Übertragbarkeit beantragen sowie seinen Widerspruch gegen die Verarbeitung derselben anmelden. Die personenbezogenen Daten werden gespeichert bis zur Erschöpfung des entsprechenden Zwecks. Dies schließt die Möglichkeit nicht aus, daß aufgrund gesetzlicher Bestimmungen die personenbezogenen Daten dieselben für eine längere Mindestfrist gespeichert werden.',	
		compreendo_informacoes: 'Ich verstehe, daß diese Informationen notwendig sind, um eine sichere und wirksame Therapie zu gewährleisten. Ich erkläre, daß die Informationen wahrheitsgemäß sind und keine wesentlichen Daten ausgelassen wurden.',	
		li_e_aceito: 'Ich habe die Bedingungen zum Schutz personenbezogener Daten durchgelesen und bin mit ihnen einverstanden',	
		autorizo_email: 'Ich bin einverstanden mit der Zusendung von Informationen und Sonderangeboten bezüglich des Spa Satsanga per Email oder auf dem Postweg.',	
		autorizo_sms: 'Ich bin einverstanden mit der Mitteilung von Informationen und Sonderangeboten bezüglich des Spa Satsanga per SMS oder Telefonanruf.',	
		submeter: 'Einreichen',	
		descricao: 'Welcher Art?',	
		semanas: 'Wochen',	
		agradecemos_questionario: 'Vielen Dank für die Beantwortung unseres Fragebogens. Bis später!',	
		vSelectNoResults: 'Keine Ergebnisse.',	
		campo_obrigatorio: 'Pflichtfeld',
		debito_ao_quarto: 'Debit Room',
		clube_vila_gale: 'Clube Vila Galé',
		massagem_tratamento: 'Massage/Behandlung',
		terapeuta: 'Therapeut',
		SideMenuOption6: 'Berichte',
		SideMenu6SubOption1: 'Abrechnung',
	},
	fr: {
		survey_name: 'Enquête de Satisfaction Client',	
		survey_message: 'Votre opinion est importante pour nous',	
		survey_table_option1: 'Excellent',	
		survey_table_option2: 'Bon',	
		survey_table_option3: 'Passable',	
		survey_table_option4: 'Mauvais',	
		survey_hotel: 'Hotel',	
		survey_treatment: 'Traitement',	
		survey_therapist: 'Nom du thérapeute',	
		survey_comments: 'Commentaires',	
		survey_thanks: 'Merci pour votre commentaire.',	
		survey_bad: 'Veuillez sélectionner une réponse pour chaque question',	
		survey_good: 'Merci pour votre collaboration',	
		survey_bad_message: 'Le questionnaire a déjà reçu une réponse',	
		survey_button: 'Soumettre',	
		survey_group1: 'Réception',	
		survey_group2: 'Traitement',	
		survey_group3: 'Installations',	
		survey_group1_item1: 'Accueil chaleureux',	
		survey_group1_item2: 'Consultation informative',	
		survey_group1_item3: 'Communication générale',	
		survey_group2_item1: 'Soins et attention',	
		survey_group2_item2: 'Technique du thérapeute',	
		survey_group2_item3: 'Qualité des produits',	
		survey_group3_item1: 'Conditions d’entretien',	
		survey_group3_item2: 'Normes d\'hygiène',	
		survey_group3_item3: 'Ambiance',	
		salutation: 'Bonjour',
		tr_to_en: 'Anglais',
		tr_to_fr: 'Le français',
		tr_to_de: 'Allemand',
		tr_to_pt: 'Portugais',
		tr_to_es: 'Espanol',
		scheduleLegend: 'Rooms',
		SideMenuOption1: 'Bookings',
		SideMenuOption2: 'Client Data',
		SideMenuOption3: 'Consult',
		SideMenu3SubOption1: 'By Therapist',
		SideMenu3SubOption2: 'By Room',
		SideMenuOption4: 'Settings',
		SideMenu4SubOption1: 'Spa',
		SideMenu4SubOption2: 'Event',
		SideMenu4SubOption3: 'Room',
		SideMenu4SubOption4: 'Therapist',
		SPA: 'SPA',
		SPA_exploracao: 'SPA Exploração',
		SideMenuOption5: 'Times',
		outras_marcacoes: 'Other Bookings',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
    	FullCalendar: 'Full Calendar',
    	SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
		Cart: 'Cart',
   		WishList: 'Wish List',
		Checkout: 'Checkout',
		UIElements: 'UI Elements',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
    	CardColors: 'Card Colors',
		Table: 'Table',
    	agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
    	ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
    	FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
    	Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
    	DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		EditorView: 'Editor View',
		AdminView: 'Admin View',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
    	StarRatings: 'Star Ratings',
    	Autocomplete: 'Autocomplete',
    	Tree: 'Tree',
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
		cliente_externo: 'Client externe',	
		socio: 'Partenaire',	
		hospede: 'Client',	
		redes_sociais: 'Réseaux sociaux',	
		website: 'Site web',	
		email: 'Courrier électronique',	
		recomendacao: 'Recommandation',	
		hotel: 'Hôtel',	
		outro: 'Autre',	
		condicoes_cardiacas: 'Problèmes cardiaques',	
		diabetes: 'Diabète',	
		asma: 'Asthme',	
		epilepsia: 'Épilepsie',	
		clastrofobia: 'Claustrophobie',	
		problemas_de_articulacoes: 'Problèmes articulaires',	
		pressao_arterial_alta_baixa: 'Haute/basse pression sanguine',	
		surdez: 'Surdité',	
		varizes: 'Varices',	
		cancro: 'Cancer',	
		lesao_acidente_recente: 'Blessure/accident récent',	
		cirurgia_recente: 'Chirurgie récente',	
		doenca_de_pele: 'Maladie de la peau',	
		gravidez: 'Grossesse',	
		amamentacao: 'Allaitement maternel',	
		alergias: 'Allergies',	
		outras: 'Autre',	
		suave: 'Douce',	
		media: 'Moyenne',	
		profunda: 'Profonde',	
		normal: 'Normale',	
		seca: 'Sèche',	
		oleosa: 'Grasse',	
		mista: 'Mixte',	
		nao: 'Non',	
		sim: 'Oui',	
		desidratada: 'Déshydratée',	
		envelhecida: 'Vieillissante',	
		rosacea: 'Rosacée',	
		sensivel: 'Sensible',	
		hiperpigmentada: 'Hyperpigmentée',	
		acne: 'Acné',	
		cartao_de_consulta: 'Carte de Consultation',	
		bem_vindo_satsanga: 'BIENVENUE À SATSANGA SPA & WELLNESS',	
		preencha_frase: 'Afin de maximiser les avantages de votre traitement pour le bien-être, nous vous demandons de lire attentivement et de remplir cette Carte de Consultation, en donnant des détails si nécessaire. Merci pour votre coopération.',	
		informacao_pessoal: 'Information Personnelle',	
		nome: 'Nom',	
		data_de_nascimento: 'Date de naissance',	
		pais: 'Nationalité',	
		contacto: 'Contact téléphonique',	
		n_quarto: 'Chambre nº',	
		tomou_conhecimento_spa: 'Comment avez-vous entendu parler de notre Spa?',	
		qual: 'Laquelle?',	
		informacoes_medicas: 'Informations médicales',	
		tratamento_de_corpo: 'Traitement du Corps',	
		marque_frase: 'Marquez les zones à éviter avec un ',	
		marque_frase_2: 'et les zones à cibler avec un',	
		limpar: 'Nettoyer',	
		direita: 'Droite',	
		posterior: 'Postérieur',	
		anterior: 'Antérieur',	
		esquerda: 'Gauche',	
		pressao_prefere: 'Quel type de pression préférez-vous pendant le massage?',	
		tratamento_do_rosto: 'Traitement du Visage',	
		tipo_de_pele: 'Type de peau',	
		tratamento_dermatologia: 'Vous suivez un traitement dermatologique?',	
		condicoes_de_pele: 'Affections de la peau',	
		termos_protecao_dados_pessoais: 'Conditions de Protection des Données Personnelles',	
		texto_proteção_dados: 'La protection des données personnelles est effectuée conformément au Règlement Général sur la Protection des Données et selon les termes suivants. Vila Galé - Sociedade de Empreendimentos Turísticos S.A. utilise les informations recueillies dans le cadre de la gestion du Spa Satsanga aux fins suivantes : services esthétiques et de beauté, traitements de massage, activités liées à l\'entretien physique et au bien-être, services de nutrition, garantie du bien-être et de l\'intégrité physique des clients pendant les traitements, à des fins de facturation, de gestion des clients, à des fins historiques et statistiques, à des fins d\'obligations légales, de contrôle de la qualité des services et pour des contacts futurs. Nous vous demandons la permission de vous envoyer des informations actualisées sur l\'activité, les produits, les services, les offres et les campagnes de Spa Satsanga par courriel ou par téléphone. L\'autorisation à des fins de marketing ne constitue pas une obligation légale ou contractuelle et il n\'y a pas de conséquences pour ceux qui ne la fournissent pas. La révocation du consentement n\'affecte pas la légalité du traitement effectué sur la base du consentement jusqu\'à la révocation. Vila Galé - Sociedade de Empreendimentos Turísticos S.A. est responsable du traitement des données collectées au Satsanga Spa, basé dans cet hôtel Vila Galé. Pour garantir la sécurité des données personnelles, nous traitons les informations que vous nous avez fournies de manière confidentielle. Vila Galé – Sociedade de Empreendimentos Turísticos S.A. peut recourir à des tiers l\'envoi des courriels et des SMS. Le titulaire des données personnelles peut déposer une plainte auprès de l\'autorité de contrôle - la Commission Nationale pour la Protection des Données. Le responsable des données peut être contacté par courrier électronique à dpo@vilagale.com , à qui vous pouvez demander à tout moment la copie de vos données, la révocation du consentement, la rectification, l\'effacement, la limitation, la portabilité et l\'opposition au traitement des dites données. Les données personnelles seront conservées jusqu\'à la fin de la durée d\'utilisation prévue. Il peut y avoir des dispositions légales exigeant que les données personnelles soient conservées pendant une période minimale.',	
		compreendo_informacoes: 'Je comprends que les informations sont nécessaires pour une thérapie sûre et efficace. Je déclare que les informations fournies sont exactes et qu\'aucune donnée pertinente n\'a été omise.',	
		li_e_aceito: 'J\'ai lu et j\'accepte les conditions relatives à la Protection des Données Personnelles',	
		autorizo_email: 'J\'autorise l\'envoi d\'informations et de promotions sur le Spa Satsanga par courrier électronique ou postal.',	
		autorizo_sms: 'J\'autorise l\'envoi d\'informations et des promotions sur le Spa Satsanga par SMS ou par appel téléphonique.',	
		submeter: 'Soumettre',	
		descricao: 'Lequel?',	
		semanas: 'Semaines',	
		agradecemos_questionario: 'Merci d\'avoir répondu à notre questionnaire. À plus tard!',	
		vSelectNoResults: 'Aucun résultat.',	
		campo_obrigatorio: 'Champs Requis',
		debito_ao_quarto: 'Debit Room',
		clube_vila_gale: 'Clube Vila Galé',
		massagem_tratamento: 'Massage/Soins',
		terapeuta: 'Thérapeute',
		SideMenuOption6: 'Rapports',
	SideMenu6SubOption1: 'Facturation',
	},
	pt: {
		survey_name: 'Questionário de Satisfação',
		survey_title: 'Pesquisa De',
		survey_subtitle: 'Satisfação Do Cliente',
		survey_message: 'A sua opinião é importante para nós',
		survey_table_option1: 'Excelente',
		survey_table_option2: 'Bom',
		survey_table_option3: 'Razoável',
		survey_table_option4: 'Mau',
		survey_hotel: 'Hotel',
		survey_treatment: 'Tratamento',
		survey_therapist: 'Nome do terapeuta',
		survey_comments: 'Comentários',
		survey_thanks: 'Obrigado pelo seu comentário.',
		survey_bad: 'Por favor selecione uma resposta para cada pergunta',
		survey_good: 'Obrigado pela sua colaboração',
		survey_bad_message: 'O questionário já foi respondido',
		survey_button: 'Submeter',
		survey_group1: 'Receção',
		survey_group2: 'Tratamento',
		survey_group3: 'Instalações',
		survey_group1_item1: 'Boas-vindas calorosas',
		survey_group1_item2: 'Consulta informativa',
		survey_group1_item3: 'Comunicação geral',
		survey_group2_item1: 'Cuidado e atenção',
		survey_group2_item2: 'Técnica terapeuta',
		survey_group2_item3: 'Qualidade dos produtos',
		survey_group3_item1: 'Condições de manutenção',
		survey_group3_item2: 'Padrões de higiene',
		survey_group3_item3: 'Ambiente',
		salutation: 'Olá',
		tr_to_en: 'Inglês',
		tr_to_fr: 'Francês',
		tr_to_de: 'Alemão',
		tr_to_pt: 'Português',
		tr_to_es: 'Espanhol',
		scheduleLegend: 'Salas',
		SideMenuOption1: 'Marcações',
		SideMenuOption2: 'Fichas de Cliente',
		SideMenuOption3: 'Consultar',
		SideMenu3SubOption1: 'Por Terapeuta',
		SideMenu3SubOption2: 'Por Sala',
		SideMenuOption4: 'Configurações',
		SideMenu4SubOption1: 'Spa',
		SideMenu4SubOption2: 'Evento',
		SideMenu4SubOption3: 'Sala',
		SideMenu4SubOption4: 'Terapeuta',
		SPA: 'SPA',
		SPA_exploracao: 'SPA Exploração',
		SideMenuOption5: 'Horários',
		outras_marcacoes: 'Outras Marcações',
		Dashboard: 'painel de controle',
		eCommerce: 'comércio eletrônico',
		Apps: 'APPS',
		Todo: 'Façam',
		Chat: 'Bate-papo',
		Email: 'O email',
		Calendar: 'Calendário',
    	FullCalendar: 'Calendário Completo',
    	SimpleCalendar: 'Calendário Simples',
		Shop: 'fazer compras',
		Cart: 'Carrinho',
    	WishList: 'Lista de Desejos',
		Checkout: 'Confira',
		UIElements: 'UI Elementos',
		DataList: 'Lista de dados',
		ListView: 'Exibição de lista',
		ThumbView: 'Thumb View',
		Grid: 'Grade',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Cores',
		Card: 'Cartão',
		Basic: 'Basic',
		Statistics: 'Estatisticas',
		Analytics: 'Analytics',
		CardActions: 'Ações do Cartão',
    	CardColors: 'Cores do cartão',
		Table: 'Mesa',
    	agGridTable: 'Tabela AgGrid',
		Components: 'Componentes',
		Alert: 'Alerta',
		Avatar: 'Avatar',
		Badge: 'Crachá',
		Breadcrumb: 'Breadcrumb',
		Button: 'Botão',
    	ButtonGroup: 'Grupo de botões',
		Chip: 'Lasca',
		Collapse: 'Colapso',
		Dialogs: 'Diálogos',
		Divider: 'Divisor',
		DropDown: 'Suspenso',
		List: 'Lista',
		Loading: 'Carregando',
		Navbar: 'Navbar',
		Notifications: 'Notificações',
		Pagination: 'Paginação',
		Popup: 'Aparecer',
		Progress: 'Progresso',
		Sidebar: 'Barra Lateral',
		Slider: 'Controle Deslizante',
		Tabs: 'Guias',
		Tooltip: 'dica de ferramenta',
		Upload: 'Envio',
		FormsAndTable: 'Formulários e tabela',
		FormElements: 'Elementos do formulário',
		Select: 'Selecione',
		Switch: 'Interruptor',
		Checkbox: 'Caixa de seleção',
		Radio: 'Rádio',
		Input: 'Entrada',
		NumberInput: 'Entrada numérica',
		Textarea: 'Textarea',
		FormLayouts: 'Layouts de formulário',
		FormWizard: 'Assistente de Formulário',
		FormValidation: 'Validação de Formulário',
    	FormInputGroup: 'Grupo de entrada de formulário',
		Pages: 'PÁGINAS',
		Authentication: 'Autenticação',
		Login: 'Entrar',
		Register: 'Registo',
		ForgotPassword: 'Esqueceu A Senha',
		ResetPassword: 'Redefinir Senha',
		LockScreen: 'Tela de bloqueio',
    	Miscellaneous: 'Diversos',
		ComingSoon: 'Em breve',
		Error: 'Erro',
		404: '404',
		500: '500',
		NotAuthorized: 'Não autorizado',
		Maintenance: 'Manutenção',
		Profile: 'Perfil',
		Invoice: 'Fatura',
		FAQ: 'Perguntas frequentes',
		Search: 'Procurar',
		KnowledgeBase: 'Base de Conhecimento',
		ChartsAndMaps: 'Gráficos E Mapas',
		Charts: 'Gráficos',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Mapa',
		Extensions: 'Extensão',
		QuillEditor: 'Quill-Editor',
		DragAndDrop: 'Arraste e solte',
		Datepicker: 'Datepicker',
    	DatetimePicker: 'Seletor de data e hora',
		AccessControl: 'Controle de acesso',
		EditorView: 'Editor View',
		AdminView: 'Vista de administração',
		I18n: 'I18n',
		Carousel: 'Carrossel',
		Clipboard: 'Prancheta',
		ContextMenu: 'Menu contextual',
    	StarRatings: 'Classificações por estrelas',
    	Autocomplete: 'autocompletar',
    	Tree: 'Árvore',
		Others: 'Outras',
		MenuLevels: 'Níveis de Menu',
		MenuLevel2p1: 'Nível de menu 2.1',
		MenuLevel2p2: 'Nível de menu 2.2',
		MenuLevel3p1: 'Nível de menu 3.1',
		MenuLevel3p2: 'Nível de menu 3.2',
		DisabledMenu: 'Menu desativado',
		Support: 'Apoio, suporte',
		Documentation: 'Documentação',
		RaiseSupport: 'Levantar Suporte',
		demoTitle: 'Título do cartão',
		demoText: `O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.`,
		cliente_externo: 'Cliente Externo',
		socio: 'Sócio',
		hospede: 'Hóspede',
		redes_sociais: 'Redes Sociais',
		website: 'Website',
		email: 'Email',
		recomendacao: 'Recomendação',
		hotel: 'Hotel',
		outro: 'Outro',
		condicoes_cardiacas: 'Condições cardíacas',
		diabetes: 'Diabetes',
		asma: 'Asma',
		epilepsia: 'Epilepsia',
		clastrofobia: 'Claustrofobia',
		problemas_de_articulacoes: 'Problemas de articulações',
		pressao_arterial_alta_baixa: 'Pressão arterial alta/baixa',
		surdez: 'Surdez',
		varizes: 'Varizes',
		cancro: 'Cancro',
		lesao_acidente_recente: 'Lesão/acidente recente',
		cirurgia_recente: 'Cirurgia recente',
		doenca_de_pele: 'Doença de pele',
		gravidez: 'Gravidez',
		amamentacao: 'Amamentação',
		alergias: 'Alergias',
		outras: 'Outras',
		suave: 'Suave',
		media: 'Média',
		profunda: 'Profunda',
		normal: 'Normal',
		seca: 'Seca',
		oleosa: 'Oleosa',
		mista: 'Mista',
		nao: 'Não',
		sim: 'Sim',
		desidratada: 'Desidratada',
		envelhecida: 'Envelhecida',
		rosacea: 'Rosácea',
		sensivel: 'Sensível',
		hiperpigmentada: 'Hiperpigmentada',
		acne: 'Acne',
		cartao_de_consulta: 'Cartão de Consulta',
		bem_vindo_satsanga: 'Bem-vindo ao SATSANGA SPA & WELLNESS',
		preencha_frase: 'De modo a maximizar os benefícios de bem-estar do seu tratamento, pedimos que leia e preencha cuidadosamente este Cartão de Consulta dando detalhes quando necessário. Obrigado pela sua colaboração.',
		informacao_pessoal: 'Informação Pessoal',
		nome: 'Nome',
		data_de_nascimento: 'Data de Nascimento',
		pais: 'País',
		contacto: 'Contacto',
		n_quarto: 'Nº Quarto',
		tomou_conhecimento_spa: 'Como tomou conhecimento do nosso Spa?',
		qual: 'Qual?',
		informacoes_medicas: 'Informações Médicas',
		tratamento_de_corpo: 'Tratamento de Corpo',
		marque_frase: 'Marque as áreas que devem ser evitadas com um ',
		marque_frase_2: 'e as áreas que devem ser focadas com um',
		limpar: 'Limpar',
		direita: 'Direita',
		posterior: 'Posterior',
		anterior: 'Anterior',
		esquerda: 'Esquerda',
		pressao_prefere: 'Que tipo de pressão prefere durante a massagem?',
		tratamento_do_rosto: 'Tratamento de Rosto',
		tipo_de_pele: 'Tipo de pele',
		tratamento_dermatologia: 'Está em algum tratamento de dermatologia?',
		condicoes_de_pele: 'Condições de pele',
		termos_protecao_dados_pessoais: 'Termos de Proteção dos Dados Pessoais',
		texto_proteção_dados: 'A Proteção de Dados Pessoais é realizada em conformidade com o Regulamento Geral de Proteção de Dados e de acordo com os seguintes termos. A Vila Galé – Sociedade de Empreendimentos Turísticos S.A. utiliza a informação recolhida no âmbito da exploração do Spa Satsanga, para as seguintes finalidades: prestação de serviços de estética e beleza, tratamentos de massagem, atividades relacionadas com a manutenção física e o bem-estar, serviços de nutrição, garantia do bem-estar e da integridade física dos clientes durante os tratamentos, para fins de faturação, gestão de clientes, fins históricos e estatísticos, obrigações legais, controle da qualidade de serviço e para contactos futuros. Solicitamos a sua autorização para o envio de informações atualizadas sobre a atividade do Spa Satsanga, sobre produtos, serviços, ofertas e campanhas, por e-mail ou telefone. A autorização para efeitos de marketing não constitui uma obrigação legal ou contratual e não existem consequências para quem não o fornecer. A retirada posterior de consentimento não compromete a licitude do tratamento realizado com base neste consentimento. A Vila Galé – Sociedade de Empreendimentos Turísticos S.A. é responsável pelo tratamento dos dados recolhidos no Spa Satsanga sediado neste Hotel Vila Galé. Para garantir a segurança dos dados pessoais tratamos a informação que nos forneceu de forma confidencial. A Vila Galé – Sociedade de Empreendimentos Turísticos S.A. pode recorrer a terceiros para o envio de e-mails e SMS. O titular dos dados pode apresentar reclamação à autoridade de controlo – a Comissão Nacional de Proteção de Dados. O Encarregado de Proteção de Dados pode ser contactado através do e-mail dpo@vilagale.com a quem poderá solicitar a qualquer momento a cópia dos dados que lhe digam respeito, a retirada do consentimento, a retificação, o apagamento, a limitação, a portabilidade e a oposição ao tratamento dos mesmos. Os dados pessoais serão mantidos até se esgotar o fim a que se destinam. Poderão existir disposições legais que obriguem a manter os dados pessoais por um período de tempo mínimo superior.',
		compreendo_informacoes: 'Compreendo que as informações são necessárias para uma terapia segura e eficiente. Declaro que a informação prestada corresponde à verdade e que não houve omissão de dados relevantes.',
		li_e_aceito: 'Li e aceito os termos relativos à Proteção de Dados Pessoais.',
		autorizo_email: 'Autorizo o envio de informação e promoções acerca do Spa Satsanga por email ou correio.',
		autorizo_sms: 'Autorizo o envio de informação e promoções acerca do Spa Satsanga por SMS ou através de chamada telefónica.',
		submeter: 'Submeter',
		descricao: 'Descrição',
		semanas: 'Semanas',
		agradecemos_questionario: 'Agradecemos por ter respondido ao nosso questionário. Até breve!',
		vSelectNoResults: 'Sem resultados.',
		campo_obrigatorio: 'Campo Obrigatório',
		debito_ao_quarto: 'Débitos ao Quarto',
		clube_vila_gale: 'Clube Vila Galé',
		massagem_tratamento: 'Massagem/Tratamento',
		terapeuta: 'Terapeuta',
		SideMenuOption6: 'Relatórios',
		SideMenu6SubOption1: 'Faturação',
	},
	es: {
		survey_name: 'Encuesta de Satisfacción del Cliente',
        survey_message: 'Su opinión es importante para nosotros',
        survey_table_option1: 'Excelente',
        survey_table_option2: 'Bueno',
        survey_table_option3: 'Razonable',
        survey_table_option4: 'Malo',
        survey_hotel: 'Hotel',
        survey_treatment: 'Tratamiento',
        survey_therapist: 'Nombre del terapeuta',
        survey_comments: 'Comentarios',
        survey_thanks: 'Gracias por su comentario.',
        survey_bad: 'Seleccione una respuesta para cada pregunta',
        survey_good: 'Gracias por su colaboración',
        survey_bad_message: 'El cuestionario ya ha sido respondido',
        survey_button: 'Entregar',
        survey_group1: 'Recepción',
        survey_group2: 'Tratamiento',
        survey_group3: 'Instalaciones',
        survey_group1_item1: 'Acogida calurosa',
        survey_group1_item2: 'Cita informativa',
        survey_group1_item3: 'Comunicación general',
        survey_group2_item1: 'Cuidado y atención',
        survey_group2_item2: 'Técnica del terapeuta',
        survey_group2_item3: 'Calidad de los productos',
        survey_group3_item1: 'Condiciones de mantenimiento',
        survey_group3_item2: 'Normas de higiene',
        survey_group3_item3: 'Ambiente',
		salutation: 'Hola',
		tr_to_en: 'Inglés',
		tr_to_fr: 'Francés',
		tr_to_de: 'Alemán',
		tr_to_pt: 'Portugués',
		tr_to_es: 'Español',
		scheduleLegend: 'Rooms',
		SideMenuOption1: 'Bookings',
		SideMenuOption2: 'Client Data',
		SideMenuOption3: 'Consult',
		SideMenu3SubOption1: 'By Therapist',
		SideMenu3SubOption2: 'By Room',
		SideMenuOption4: 'Settings',
		SideMenu4SubOption1: 'Spa',
		SideMenu4SubOption2: 'Event',
		SideMenu4SubOption3: 'Room',
		SideMenu4SubOption4: 'Therapist',
		SPA: 'SPA',
		SPA_exploracao: 'SPA Exploração',
		SideMenuOption5: 'Times',
		outras_marcacoes: 'Other Bookings',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
    	FullCalendar: 'Full Calendar',
    	SimpleCalendar: 'Simple Calendar',
		Shop: 'Shop',
		Cart: 'Cart',
   		WishList: 'Wish List',
		Checkout: 'Checkout',
		UIElements: 'UI Elements',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
    	CardColors: 'Card Colors',
		Table: 'Table',
    	agGridTable: 'agGrid Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
    	ButtonGroup: 'Button Group',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		FormsAndTable: 'Forms & Table',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
    	FormInputGroup: 'Form Input Group',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
    	Miscellaneous: 'Miscellaneous',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
    	DatetimePicker: 'Datetime Picker',
		AccessControl: 'Access Control',
		EditorView: 'Editor View',
		AdminView: 'Admin View',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
    	StarRatings: 'Star Ratings',
    	Autocomplete: 'Autocomplete',
    	Tree: 'Tree',
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
		cliente_externo: 'External Guest',
		socio: 'Spa Member',
		hospede: 'Hotel Guest',
		redes_sociais: 'Social Media',
		website: 'Website',
		email: 'Email',
		recomendacao: 'Recommendation',
		hotel: 'Hotel',
		outro: 'Other',
		condicoes_cardiacas: 'Heart Condition',
		diabetes: 'Diabetes',
		asma: 'Asthma',
		epilepsia: 'Epilepsy',
		clastrofobia: 'Claustrophobia',
		problemas_de_articulacoes: 'Joint Problem',
		pressao_arterial_alta_baixa: 'High/Low Blood Pressure',
		surdez: 'Hearing Disease',
		varizes: 'Varicose Veins',
		cancro: 'Cancer',
		lesao_acidente_recente: 'Recent Injury/Accident',
		cirurgia_recente: 'Recent surgery',
		doenca_de_pele: 'Skin Disease Condition',
		gravidez: 'Pregnancy',
		amamentacao: 'Breastfeeding',
		alergias: 'Allergies',
		outras: 'Other',
		suave: 'Soft',
		media: 'Medium',
		profunda: 'Deep',
		normal: 'Normal',
		seca: 'Dry',
		oleosa: 'Oily',
		mista: 'Combination',
		nao: 'No',
		sim: 'Yes',
		desidratada: 'Dehydrated',
		envelhecida: 'Mature',
		rosacea: 'Rosacea',
		sensivel: 'Sensitive',
		hiperpigmentada: 'Hyperpigmented',
		acne: 'Acne',
		cartao_de_consulta: 'Consultation Card',
		bem_vindo_satsanga: 'Welcome to SATSANGA SPA & WELLNESS',
		preencha_frase: 'In order to maximize the wellness benefits of your treatment, we kindly ask you to read this Consultation Card, carefully and complete it, giving details as needed. Thank you for your collaboration.',
		informacao_pessoal: 'Personal Information',
		nome: 'Name',
		data_de_nascimento: 'Birthday Date',
		pais: 'Nationality',
		contacto: 'Contact',
		n_quarto: 'Room Nº',
		tomou_conhecimento_spa: 'How did you find out about our Spa?',
		qual: 'Which?',
		informacoes_medicas: 'Medical Information',
		tratamento_de_corpo: 'Body Treatment',
		marque_frase: 'Check areas to avoid with a ',
		marque_frase_2: 'and areas that should be focused with a',
		limpar: 'Clean',
		direita: 'Left',
		posterior: 'Back',
		anterior: 'Front',
		esquerda: 'Right',
		pressao_prefere: 'What type of pressure do you prefer during the massage?',
		tratamento_do_rosto: 'Face Treatment',
		tipo_de_pele: 'Skin Type',
		tratamento_dermatologia: 'Are you on any specific dermatology treatment?',
		condicoes_de_pele: 'Skin Conditions',
		termos_protecao_dados_pessoais: 'Privacy and Personal Data Protection',
		texto_proteção_dados: 'All personal information is processed under compliance of the General Data Protection Regulation and the following terms.Vila Galé - Sociedade de Empreendimentos Turísticos S.A. uses your personal information to provide beauty and massage treatments, gym and nutrition services, to guarantee our clients´ well-being during treatments, customer management, historical and statistical purposes, legal obligations, quality control and for future contacts.If consented, Vila Galé - Sociedade de Empreendimentos Turísticos S.A. will send you information about our products and services either by email, text messages or telephone call. Authorization for marketing purposes is not a legal or contractual obligation and there are no consequences for those who do not provide it. The subsequent withdrawal of consent does not compromise the lawfulness of the process based on this consent. Vila Galé - Sociedade de Empreendimentos Turísticos S.A. is the responsible for the data collected at this Satsanga Spa and will process it in accordance with its internal policies and procedures on security and confidentiality. Vila Galé Group may use third parties to send e-mails and text messages. For any inquiries you may contact the portuguese supervisory authority - Comissão Nacional de Proteção de Dados. The Data Protection Officer can be contacted directly by e-mail at dpo@vilagale.com to whom you may request at any time the access, correction, erasure, data portability and the right to object or restrict processing. We retain personal information for the period necessary to fulfil the outlined purposes, unless a longer retention period is required or permitted by applicable law.',
		compreendo_informacoes: 'I understand that this information is necessary to an efficient and safe treatment. I declare that the information provided is accurate and that there was no omission of relevant information.',
		li_e_aceito: 'I read and agree with the Privacy and Personal Data Protection Policy',
		autorizo_email: 'I wish to receive occasional emails about Satsanga Spa products, promotions and news by e-mail.',
		autorizo_sms: 'I wish to receive occasional emails about Satsanga Spa products, promotions and news by text or by phone call.',
		submeter: 'Submit',
		descricao: 'Specify',
		semanas: 'Weeks',
		agradecemos_questionario: 'Thank you for responding to our questionnaire. See you later!',
		vSelectNoResults: 'No results found.',
		campo_obrigatorio: 'Required field',
		debito_ao_quarto: 'Debit Room',
		clube_vila_gale: 'Clube Vila Galé',
		massagem_tratamento: 'Masaje/Tratamiento',
		terapeuta: 'Terapeuta',
		SideMenuOption6: 'Informes',
		SideMenu6SubOption1: 'Facturación',
	},
}
